import { useTranslation } from '@rbx/intl';
import { Typography } from '@rbx/ui';
import React, { FC } from 'react';
import useRegeneratedResponseHeaderStyles from './RegeneratedResponseHeader.styles';

type RegeneratedResponseHeaderProps = {
  regeneratedPrompt: string;
};

const RegeneratedResponseHeader: FC<React.PropsWithChildren<RegeneratedResponseHeaderProps>> = ({
  regeneratedPrompt,
}) => {
  const {
    classes: { header },
  } = useRegeneratedResponseHeaderStyles();
  const { translate } = useTranslation();
  return (
    <Typography
      aria-roledescription={translate('Label.RegeneratedResponseHeader')}
      color='disabled'
      variant='body1'
      component='div'
      marginBottom={2}>
      <span className={header}>{translate('RegeneratedResponse.TagText')}:</span>{' '}
      {regeneratedPrompt}
    </Typography>
  );
};

export default RegeneratedResponseHeader;
